/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { C as Content, d as defineCustomElement$1 } from './content.js';

const IonContent = Content;
const defineCustomElement = defineCustomElement$1;

export { IonContent, defineCustomElement };
